module.exports = __webpack_public_path__ + "i18n/ru.bded23b902f11f6f3f94fd5797cd8ecd.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1315
// module chunks = 59